import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles scroll behavior on every route change:
 *  • If the URL has a hash (#guide-form, #contact, etc), scroll to that element.
 *    React Router doesn't auto-honor hashes by default, so we do it here.
 *  • Otherwise, scroll to the top.
 *
 * Place once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1); // strip the leading #
      // Wait one frame so the destination route's content is mounted, then scroll.
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          // Fallback: hash points to a non-existent element → scroll to top
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
